<template>
  <div class="tw:border tw:border-blue-600 tw:rounded-xl tw:bg-white tw:px-5 tw:py-4">
    <!-- Brand header row -->
    <div class="tw:flex tw:items-center tw:justify-between tw:mb-3">
      <img :src="businessStudioPlusLogo" class="tw:h-4 tw:self-center" alt="trivago Business Studio+" />
      <button
        @click="$emit('dismiss')"
        class="tw:text-gray-400 tw:hover:text-gray-600 tw:p-1 tw:rounded tw:hover:bg-gray-100 tw:transition-colors"
        :aria-label="$t('close')"
      >
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11 3L3 11M3 3L11 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
        </svg>
      </button>
    </div>

    <!-- Content row -->
    <div class="tw:flex tw:flex-col tw:md:flex-row tw:md:items-end tw:gap-4">
      <div class="tw:flex-1">
        <h1 class="tw:font-bold tw:text-xl tw:mb-4">{{ $t('pro_plus_header') }}</h1>
        <p>{{ $t('subscription_reactivation_subtext') }}</p>
      </div>
      <GhostButton class="tw:shrink-0 tw:px-8" @click="$emit('openModal')">
        {{ $t('business_studio_plus_learn_cta') }}
      </GhostButton>
    </div>
  </div>
</template>

<script setup>
import GhostButton from '@/components/base/buttons/GhostButton.vue'
const businessStudioPlusLogo = new URL('/src/assets/img/landing/landing_studio_plus.svg', import.meta.url)

defineEmits(['openModal', 'dismiss'])
</script>
